import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import React from "react";
import "./style.css";
import { FormattedMessage } from "react-intl";

const EmptyParties = props => {
  const { emptyLabel, onButtonClick } = props;

  return (
    <div className="empty-parties">
      <FontAwesomeIcon
        icon={["far", "book-open"]}
        className="empty-parties-icon"
      />
      <div className="empty-parties-text">{emptyLabel}</div>
      {onButtonClick && (
        <Button
          kind="secondary"
          colorScheme={"ghost"}
          className="empty-parties-button"
          onClick={() => onButtonClick()}
        >
          <FormattedMessage id="addressBook.addFirst" />
        </Button>
      )}
    </div>
  );
};

export default EmptyParties;
